import React from "react";
import ModalGeneral from "../common/scripts/ModalGeneralComponent";
import { Tab, Tabs, Panel, PanelGroup, Alert } from 'react-bootstrap';

export class Surveys extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      configurations: {},
      userInfo: this.props.userInfo,
      items: this.props.surveys,
      screen: window.innerWidth,
      showImg: "fa fa-world",
      titleModal: "",
      messageModal: "",
      iconoModal: "",
      colorIco: "",
      noX: "",
      noAceptar: "",
      activeKey: null,
      noCancelar: "",
      show: true,
      tabKey: 1,
      activeErrorMessage: false,
      block: false,
      showModal: false,
    };
    this.pnpService = new ServicioPnp();
    this.activeModal = this.activeModal.bind(this);
    this.handleModalConfirm = this.handleModalConfirm.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.handleRedirectOtherPage = this.handleRedirectOtherPage.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleSelectTab = this.handleSelectTab.bind(this);
    this.handleSelectPanel = this.handleSelectPanel.bind(this);
    this.nextTab = this.nextTab.bind(this);

    this.cardButtonFlex = {
      display: "flex",
      flexDirection: "column",
      marginTop: "10px",
      alignItems: "center",
    };
    this.positionInherit = { position: "inherit" };
  }

  componentDidMount() {
    // compensar.mostrarLoading("#encuestaSatisfaccionForm");
  }


  doneSurveysItems() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 not-access">
        <i className="fa fa-smile-o"></i>
        <h4>
          {landingEncuestaResources.getResource(
            "es",
            "nsLandingEncuesta",
            "Form.Content.doneSurveys"
          )}
        </h4>
      </div>
    );
  }

  botonVerIndividua(link, texto) {
    return (
      <a
        style={{
          position: "inherit",
          backgroundColor: "white",
          color: "#ff6600",
        }}
        target="_blank"
        href={link}
        className="btn btn-block btn-default"
      >
        {texto}
      </a>
    );
  }

  botonVerMas(certificate) {
    let btn;
    if (certificate.Name === 'EPOC') {
      btn = this.botonVerIndividua(
        landingEncuestaResources.getResource("es", "nsLandingEncuesta", "Form.Content.SaberMasHrefEPOC"),
        landingEncuestaResources.getResource("es", "nsLandingEncuesta", "Form.Content.SaberMas")
      );
    } else if (certificate.Name.trim() === 'Findrisk' || certificate.Name === 'DIABETES') {
      btn = this.botonVerIndividua(
        landingEncuestaResources.getResource("es", "nsLandingEncuesta", "Form.Content.SaberMasHrefFindrisk"),
        landingEncuestaResources.getResource("es", "nsLandingEncuesta", "Form.Content.SaberMas")
      );
    }
    return btn;
  }

  renderSurveysCardsContributorDesktop(items) {
    let view;
    this.advantagePercent(items);
    const isContributor = items.filter((item) => {
      return item.IsContributor === true;
    });
    if (isContributor[0].SurveysList.length !== 0) {
      view = this.renderForIpad(isContributor);
    } else {
      view = this.doneSurveysItems();
    }
    return view;
  }

  renderSurveysCardsBeneficiaryDesktop(items) {
    let view;
    this.advantagePercent(items);
    const isBeneficiary = items.filter((item) => {
      return item.IsContributor === false;
    });
    if (isBeneficiary[0].SurveysList.length !== 0) {
      view = this.renderForIpad(isBeneficiary);
    } else {
      view = this.doneSurveysItems();
    }
    return view;
  }

  accordenBeneficiaries(items) {
    const beneficiaries = items.filter((item) => {
      return item.IsContributor === false;
    });
    return (
      <div>
        <PanelGroup
          accordion
          id="accordion-controlled-example"
          activeKey={this.state.activeKey}
          onSelect={this.handleSelectPanel}
        >
          {beneficiaries.map((beneficiary, index) => {
            return (
              <Panel eventKey={index}>
                <Panel.Heading>
                  <Panel.Title toggle>
                    {this.state.activeKey !== index ? (
                      beneficiary.FullName
                    ) : (
                      <span className="orange">{beneficiary.FullName}</span>
                    )}
                    {this.state.activeKey !== index ? (
                      <i className="fa fa-chevron-down"></i>
                    ) : (
                      <i className="fa fa-chevron-up orange"></i>
                    )}
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  {this.renderSurveysBeneficiaries(beneficiary)}
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-percent">
                    {beneficiary.SurveysList.length !== 0
                      ? this.advantagePercentPerBenefeciaries(
                          beneficiary.SurveysList
                        )
                      : this.advantageDefault()}
                  </div>
                </Panel.Body>
              </Panel>
            );
          })}
        </PanelGroup>
      </div>
    );
  }

  renderSurveysBeneficiaries(data) {
    let items = data.SurveysList;
    let view;
    if (items.length !== 0) {
      view = this.renderForIpad([data]);
    } else {
      view = this.doneSurveysItems();
    }
    return view;
  }

  advantagePercentPerBenefeciaries(items) {
    let view;
    let isComplete = items.filter((item) => {
      return item.IsCompleted === true;
    });

    let total =
      (isComplete.length /
        this.itemslengthToEvoidAdvantageDivisionError(items)) *
      100;
    view = (
      <div className="text-center">
        <h1>
          {parseInt(total)}% - Has completado {isComplete.length} de{" "}
          {items.length} test
        </h1>
      </div>
    );
    return view;
  }

  itemslengthToEvoidAdvantageDivisionError(items) {
    if (
      items.length == undefined ||
      items.length == null ||
      items.length == 0
    ) {
      return 1;
    } else {
      return items.length;
    }
  }

  advantagePercent(items) {
    let view;
    if (this.state.block === false) {
      let isPerson = items.filter((item) => {
        return item.IsContributor === true;
      });
      if (isPerson.length === 1) {
        let isCompleteContributor = isPerson[0].SurveysList.filter((item) => {
          return item.IsCompleted === true;
        });
        let total =
          (isCompleteContributor.length /
            this.itemslengthToEvoidAdvantageDivisionError(
              isPerson[0].SurveysList
            )) *
          100;
        view = (
          <div className="text-center">
            <h1>
              {parseInt(total)}% - Has completado {isCompleteContributor.length}{" "}
              de {isPerson[0].SurveysList.length} test
            </h1>
          </div>
        );
      } else {
        let isComplete = items[0].SurveysList.filter((item) => {
          return item.IsCompleted === true;
        });
        let total =
          (isComplete.length /
            this.itemslengthToEvoidAdvantageDivisionError(
              items[0].SurveysList
            )) *
          100;
        view = (
          <div className="text-center">
            <h1>
              {parseInt(total)}% - Has completado {isComplete.length} de{" "}
              {items[0].SurveysList.length} test
            </h1>
          </div>
        );
      }
      return view;
    } else {
      view = (
        <div className="text-center">
          <h1>0% - Has completado 0 de 0 test</h1>
        </div>
      );
    }
    return view;
  }

  advantageDefault() {
    return (
      <div>
        <hr className="line" style={{width: '100%'}} />
        <div className="text-center">
          <h1>0% - Has completado 0 de 0 test</h1>
        </div>
      </div>
    );
  }
  nextTab() {
    if (this.state.tabKey === 2) {
      this.setState({ tabKey: this.state.tabKey - 1 });
    } else {
      this.setState({ tabKey: this.state.tabKey + 1 });
    }
  }

  renderForIpad(data) {
    let items = data[0].SurveysList;
    let showImg = this.state.showImg;
    let screenDevice;
    if (screen.width > 1024) {
      screenDevice = 4;
    } else {
      screenDevice = 3;
    }
    return (
      <div>
        <div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 renderLanscape">
            {items.map((certificate) => {
              return (
                <div className="contentCertification ">
                  <div
                    className={
                      showImg
                        ? "cardCertification col-xs-12 col-sm-12 col-md-3 col-lg-3"
                        : "cardCertification col-xs-12 col-sm-12 col-md-3 col-lg-3 inside"
                    }
                  >
                    <div
                      className={
                        certificate.IsCompleted === true
                          ? "done-icon"
                          : "circle-icon"
                      }
                      style={{ display: showImg ? "block" : "none" }}
                    >
                      {certificate.IsCompleted === true ? (
                        <i
                          className={landingEncuestaResources.getResource(
                            "es",
                            "nsLandingEncuesta",
                            "Form.Content.doneCard"
                          )}
                        />
                      ) : (
                        <i
                          className={landingEncuestaResources.getResource(
                            "es",
                            "nsLandingEncuesta",
                            "Form.Content.iconCard"
                          )}
                        />
                      )}
                    </div>
                    <div className="cardTitle">
                      <h4>{certificate.Name}</h4>
                    </div>
                    <div className="cardDescription">
                      <p>{certificate.Description}</p>
                    </div>
                    <div
                      className={showImg ? "cardButton" : "altCardButton"}
                      style={this.cardButtonFlex}
                    >
                      {certificate.IsCompleted === true ? (
                        <a
                          style={this.positionInherit}
                          onClick={this.redirectEncuesta.bind(
                            this,
                            certificate,
                            data
                          )}
                          className="btn btn-block btn-default"
                        >
                          {landingEncuestaResources.getResource(
                            "es",
                            "nsLandingEncuesta",
                            "Form.Content.testDone"
                          )}
                        </a>
                      ) : (
                        <a
                          style={this.positionInherit}
                          onClick={this.redirectEncuesta.bind(
                            this,
                            certificate,
                            data
                          )}
                          href={certificate.url}
                          className="btn btn-block btn-default"
                        >
                          {landingEncuestaResources.getResource(
                            "es",
                            "nsLandingEncuesta",
                            "Form.Content.testStart"
                          )}
                        </a>
                      )}
                      {this.botonVerMas(certificate)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <hr className="line" />
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          {this.advantagePercent(this.state.items)}
        </div>
      </div>
    );
  }

  alertMessage() {
    return this.state.show === true ? (
      <Alert bsStyle="info" onDismiss={this.handleDismiss}>
        <div className="contentMessage">
          <p className="textMessage notIcon">
            <i
              className={landingEncuestaResources.getResource(
                "es",
                "nsLandingEncuesta",
                "Form.Content.iconMessage"
              )}
            ></i>
            {landingEncuestaResources.getResource(
              "es",
              "nsLandingEncuesta",
              "Form.Content.infoMessage"
            )}
          </p>
          <p className="textMessage spaceBr text-center">
            <i
              className={landingEncuestaResources.getResource(
                "es",
                "nsLandingEncuesta",
                "Form.Content.iconMessage"
              )}
            ></i>
            <br />
            {landingEncuestaResources.getResource(
              "es",
              "nsLandingEncuesta",
              "Form.Content.infoMessage"
            )}
          </p>
        </div>
      </Alert>
    ) : null;
  }

  renderTabPanelsIsLogged(items) {
    let view;

    const hasBeneficiaries = items.filter((item) => {
      return item.IsContributor === false;
    });

    const hasContributor = items.filter((item) => {
      return item.IsContributor === true;
    });

    if (hasContributor.length !== 0 && items.length > 1) {
      //Se obtuvieron cotizante y beneficiarios
      view = (
        <div>
          <div className="row tabsController mobile">
            <div className="nextTabControl col-md-6">
              <a className="mobile" onClick={this.nextTab.bind(this)}>
                <i className="fa fa-chevron-right"></i>
              </a>
            </div>
          </div>
          <Tabs
            id="noanim-tab-example"
            activeKey={this.state.tabKey}
            onSelect={this.handleSelectTab}
          >
            <Tab
              eventKey={1}
              title={landingEncuestaResources.getResource(
                "es",
                "nsLandingEncuesta",
                "Form.Content.Tab1"
              )}
            >
              {this.renderSurveysCardsContributorDesktop(items)}
            </Tab>
            <Tab
              eventKey={2}
              title={landingEncuestaResources.getResource(
                "es",
                "nsLandingEncuesta",
                "Form.Content.Tab2"
              )}
            >
              {this.accordenBeneficiaries(items)}
            </Tab>
          </Tabs>
        </div>
      );
    } else if (items.length === 1) {
      //Se obtuvo un solo usuario (cotizante ó beneficiario)
      if (hasBeneficiaries.length !== 0) {
        view = (
          <div>
            <div className="row tabsController mobile">
              <div className="nextTabControl col-md-6">
                <a className="mobile" onClick={this.nextTab.bind(this)}>
                  <i className="fa fa-chevron-right"></i>
                </a>
              </div>
            </div>
            {this.renderSurveysCardsBeneficiaryDesktop(hasBeneficiaries)}
          </div>
        );
      } else {
        view = (
          <div>
            <div className="row tabsController mobile">
              <div className="nextTabControl col-md-6">
                <a className="mobile" onClick={this.nextTab.bind(this)}>
                  <i className="fa fa-chevron-right"></i>
                </a>
              </div>
            </div>
            {this.renderSurveysCardsContributorDesktop(hasContributor)}
          </div>
        );
      }
    } else {
      if (items[0].SurveysList.length !== 0) {
        view = this.renderForIpad(items[0].SurveysList);
      } else {
        view = this.doneSurveysItems();
      }
    }
    return view;
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleModalCancel() {}

  handleModalConfirm() {
    this.handleRedirectOtherPage();
  }

  handleRedirectOtherPage() {
    window.location.href =
      _spPageContextInfo.siteAbsoluteUrl +
      landingEncuestaResources.getResource(
        "es",
        "nsLandingEncuesta",
        "Form.Content.UrlRedirect"
      );
  }

  handleSelectTab(activeKey) {
    this.setState({ tabKey: activeKey });
  }

  handleSelectPanel(activeKey) {
    this.setState({ activeKey: activeKey });
  }

  activeModal(
    title,
    btnCerrarCancelar,
    message,
    icono,
    colorIco,
    noX,
    noAceptar,
    noCancelar
  ) {
    this.setState({
      titleModal: title,
      btnCerrarCancelar: btnCerrarCancelar,
      messageModal: message,
      iconoModal: icono,
      colorIco: colorIco,
      noX: noX,
      noAceptar: noAceptar,
      noCancelar: noCancelar,
      showModal: true,
    });
  }

  getErrorMessage(error, btnCerrarCancelar, btnAceptar, btnCerrar) {
    return this.activeModal(
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Title.Error"
      ),
      btnCerrarCancelar,
      error,
      sharedResources.getResource("es", "nsGeneralResources", "Iconos.Error"),
      sharedResources.getResource("es", "nsGeneralResources", "Colores.Azul"),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.False"
      ),
      btnAceptar,
      btnCerrar
    );
  }

  redirectEncuesta(data, user) {
    data.IsCompleted
      ? this.getModalResponse(data, user)
      : this.redirectEncuestaFlujo(data, user);
  }

  getModalResponse(data, user) {
    let dataToStorage = {};
    dataToStorage.isCompleteSurvey = data;
    dataToStorage.userInformation = user[0];
    this.props.handleSelectEncuesta(dataToStorage)
  }

  redirectEncuestaFlujo(data, user) {
    let dataToStorage = {};
    dataToStorage.isCompleteSurvey = data;
    dataToStorage.userInformation = user[0];

    dataToStorage.isCompleteSurvey.Name = data.Name;
    dataToStorage.isCompleteSurvey.isComplete = false;
    this.props.handleSelectEncuesta(dataToStorage)
  }

  getDataCatch() {
    return this.activeModal(
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Title.Error"
      ),
      "Cerrar",
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Lead.ErrorSistema"
      ),
      sharedResources.getResource("es", "nsGeneralResources", "Iconos.Error"),
      sharedResources.getResource("es", "nsGeneralResources", "Colores.Azul"),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.False"
      ),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.False"
      ),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.True"
      )
    );
  }

  accessDenied() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 accessDenied">
        <h1>Lo sentimos este sitio no ha sido compartido con usted.</h1>
      </div>
    );
  }

  handleHide() {

  }

  handleAction() {
    
  }

  render() {
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12 selectorPadre"
      >
        <ModalGeneral
          MessageTitle={this.state.titleModal}
          msg={this.state.messageModal}
          Icono={this.state.iconoModal}
          NoX={this.state.noX}
          NoAceptar={this.state.noAceptar}
          NoCancelar={this.state.noCancelar}
          colorIco={this.state.colorIco}
          showModal={this.state.showModal}
          handleHide={this.handleHide.bind(this)}
          AltButtonText={sharedResources.getResource(
            "es",
            "nsGeneralResources",
            "Modal.Buttons.Aceptar"
          )}
          MainButtonText={sharedResources.getResource(
            "es",
            "nsGeneralResources",
            "Modal.Buttons.Cerrar"
          )}
          MainButtonAction={() => this.setState({ showModal: false })}
          AltButtonAction={this.handleAction.bind(this)}
        />
        <div>
          <div>
            <div className="header-component">
              <h1>
                {landingEncuestaResources.getResource(
                  "es",
                  "nsLandingEncuesta",
                  "Form.Content.Title"
                )}
              </h1>
            </div>
            <div>{this.alertMessage()}</div>
            <div>
              {
                this.renderTabPanelsIsLogged(this.state.items)
              }
            </div>
            <a className="linkVolver" onClick={this.props.handleVolverALogin}>Volver</a>
          </div>
        </div>
      </div>
    );
  }
}

// const Tabs = ReactBootstrap.Tabs;
// const Tab = ReactBootstrap.Tab;
// const Alert = ReactBootstrap.Alert;
// const PanelGroup = ReactBootstrap.PanelGroup;
// const Panel = ReactBootstrap.Panel;
